import type { IntlShape } from 'react-intl';
import type { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';
import type { User } from '@alltrails/types/User';
import footerLinks, { FooterLinksType } from '../generateFooterLinks';
import DesktopLinks from './DesktopLinks';
import MobileLinks from './MobileLinks';
import styles from './styles.module.scss';

type Props = {
  intl: IntlShape;
  languageRegionCode: LanguageRegionCode;
  user?: User | null;
  irclickid?: string;
};

const FooterLinks = ({ intl, languageRegionCode, user, irclickid }: Props) => {
  const linkData = footerLinks({ intl, languageRegionCode, user, irclickid });

  return (
    <nav className={styles.nav}>
      <div className={styles.expandableContainer}>
        {linkData.map((link: FooterLinksType) => (
          <MobileLinks
            amplitudeEventName={link.amplitudeEventName}
            key={link.title}
            href={link.href}
            childLinks={link.childLinks}
            title={link.title}
          />
        ))}
      </div>
      <div className={styles.footerLinksContainer}>
        {linkData.map((link: FooterLinksType) => (
          <DesktopLinks
            amplitudeEventName={link.amplitudeEventName}
            key={link.title}
            href={link.href}
            childLinks={link.childLinks}
            title={link.title}
          />
        ))}
      </div>
    </nav>
  );
};

export default FooterLinks;
